document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll('.river-banner--fade-item');
  if (!items.length) return;

  let index = 0;

  // Initial
  items[index].classList.add('is-active');

  setInterval(() => {
    // Nettoyer toutes les classes à chaque étape
    items.forEach((item, i) => {
      item.classList.remove('is-active', 'is-prev');
    });

    // Marquer l'ancien comme 'prev'
    const prevIndex = index;
    index = (index + 1) % items.length;

    items[prevIndex].classList.add('is-prev');
    items[index].classList.add('is-active');
  }, 3500);
});
